import AreaImprovementMaintenance from '../pages/AreaImprovementMaintenance';

const areaImprovementRoute = {
  public: [],
  auth: [
    {
      name: 'approvals_cwp',
      path: '/maintenence/area-for-imporvements',
      permissions: ['admin'],
      component: AreaImprovementMaintenance,
    },
  ],
};

export default areaImprovementRoute;
